import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import { environment } from '@environments/environment';
import { StorageService } from './storage.service';

@Injectable()
export class PusherService {
	private echo: any;

	private defaultConfig: any = {
		broadcaster: 'pusher',
		key: environment.pusher_key,
		cluster: 'eu',
		encrypted: true,
		namespace: false,
	};

	/**
	 * Constructs class and injects dependencies. Initialises echo.
	 */
	constructor(
		private http_client: HttpClient,
		private storage_service: StorageService,
	) {
		window['Pusher'] = Pusher;
		this.echo = new Echo(this.defaultConfig);
	}

	/**
	 * Sets pusher config.
	 *
	 * @param overrideConfig
	 */
	setConfig(overrideConfig: any): void {
		const config: any = Object.assign({}, this.defaultConfig, overrideConfig);

		if (config.authEndpoint) {
			config.authorizer = (channel: any, options: any) => ({
				authorize: (socket_id: string, callback: (error: any, data: any) => void): void => {
					const enquiryHash = options.auth?.params?.hash;
					const token = enquiryHash ? this.storage_service.getItem('token-' + enquiryHash) : '';

					if (!token) {
						callback(new Error('Enquiry authorization token is unavailable.'), null);
						return;
					}

					let params = new HttpParams()
						.set('socket_id', socket_id)
						.set('channel_name', channel.name);

					Object.keys(options.auth?.params || {}).forEach((key) => {
						params = params.set(key, options.auth.params[key]);
					});

					const headers = new HttpHeaders(options.auth?.headers || {})
						.set('Authorization', 'Bearer ' + token)
						.set('Content-Type', 'application/x-www-form-urlencoded');

					this.http_client.post(config.authEndpoint, params.toString(), { headers }).subscribe({
						next: (response) => callback(null, response),
						error: (error) => callback(error, null),
					});
				},
			});
		}

		this.echo = new Echo(config);
	}

	/**
	 * Joins pusher channel.
	 *
	 * @param {string} channelName
	 *
	 * @returns {}
	 */
	join(channelName: string): any {
		return this.echo.join(channelName);
	}

	/**
	 * Subscribes to pusher channel.
	 *
	 * @param {string} channelName
	 *
	 * @returns {}
	 */
	subscribe(channelName: string): any {
		return this.echo.subscribe(channelName);
	}

	/**
	 * Returns socket id.
	 *
	 * @returns {string}
	 */
	socketId(): string {
		return this.echo.socketId();
	}
}
